import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import {
  Breadcrumbs,
  Columns,
  OverviewCard,
  PageTitleAndSubTitle,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import React, { ChangeEvent, useEffect, useState } from 'react';
import EditDurationModal from '../../_components/molecules/EditDurationModal';
import { useStores } from '../../stores';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import axios from 'axios';
import properties from '../../core-utils/properties';
import {
  formatCostValues,
  formatMemberValues,
  formatTotalCost,
  titleAndSubtitles,
} from '../../core-utils/helper-utils/cohortAnalysisHelper';
import Loader from '../../_components/molecules/Loader';
import { observer } from 'mobx-react';
import { useNavigate } from 'react-router-dom';
import { pageScrollDown } from '../SummaryPage';
import { PATIENT_DETAILS } from '../../core-utils/routes';
import moment from 'moment';
import CustomColumnsTable from '../../_components/organisms/CustomColumnsTable';
import {
  columnsDropdownOptions,
  formatMembersListData,
  getCohortDefaultColumns,
  getColumns,
} from '../../core-utils/helper-utils/customColumnsHelper';
import { handleDownloadCSV } from '../../core-utils/helper-utils/downloadPdfHelper';
import Snackbar from '../../_components/atoms/Snackbar';
import { AlertColor as MuiColor } from '@mui/material/Alert';
import { toJS } from 'mobx';
import CohortAnalysisModal from '../../_components/atoms/CohortAnalysisModal';
import OverviewCardTooltipContent from '../../_components/atoms/OverviewCardTooltipContent';
import { getCohortValue } from '../../core-utils/helper-utils/overviewCardHelper';
import {
  CostValues,
  getPmpmValueForCohorts,
  MemberValues,
  PMPM,
  TotalCost,
} from '../../core-utils/helper-utils/summaryReportHelper';
import useTotalEligible from '../../core-utils/custom-hooks/TotalEligible';
import { numberToCurrencyFormatter } from '../../core-utils/helper-utils/helper';
import QueryIcon from '../../_components/atoms/Icons/QueryIcon';
import { getTextWithToolTip } from '../../core-utils/helper-utils/riskPatientDetailsHelper';
// import {
//   checkUserAccess,
//   UserAccessConstants,
// } from '../../core-utils/helper-utils/userAccess';

const useStyles = makeStyles()({
  root: {
    display: 'flex',
    flexDirection: 'column',
    padding: '40px 0px 66px 63px',
    width: '1234px',
  },
  flex: {
    display: 'flex',
  },
  queryIconGrid: {
    padding: '10px 0px 10px 22px',
  },
  queryDataOverallGrid: {
    margin: '30px 10px 0px 0px',
    height: '44px',
    backgroundColor: '#FFFFFF',
    border: '1px solid #DADEEF',
    width: '1176px',
    borderRadius: '4px',
    flexWrap: 'nowrap',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  queryDataTypography: {
    padding: '10px 10px',
    height: '44px',
    borderRight: '1px solid #DADEEF',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  queryDataGrid: {
    maxWidth: '1377px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    minWidth: '60px',
  },
  editQueryGrid: {
    padding: '10px 40px',
    backgroundColor: '#FFFFFF',
    border: '1px solid #DADEEF',
  },
  customTable: {
    marginTop: '30px',
  },
});

export interface CohortScreenProps {
  type: 'chronic' | 'cost' | 'drugs';
}

const CohortScreen: React.FC<CohortScreenProps> = observer(({ type }) => {
  const { classes } = useStyles();
  const employerGroupStore = useStores().employerGroupStore;
  const memberSummaryStore = useStores().memberSummaryStore;
  const cohortDetailsStore = useStores().cohortDetailsStore;
  // const loginPageStore = useStores().loginPageStore;

  const navigate = useNavigate();
  const defaultSelectedColumns = getCohortDefaultColumns(type);

  const breadcrumbs = [
    [
      'text',
      'Cohort Analysis',
      {
        color: patientAccessTheme.palette.primary[500],
        fontWeight: 500,
      },
      () => {
        navigate(-1);
      },
    ],
    [
      'text',
      titleAndSubtitles[type]?.title,
      {
        color: patientAccessTheme.palette.text.highemphasis,
        fontWeight: 600,
      },
    ],
  ];
  const previousYearCostSortFields = [
    'previousYearCost',
    'prevMedicalCost',
    'prevRxCost',
  ];

  //states
  const [startDate, setStartDate] = useState<string>('');
  const [endDate, setEndDate] = useState<string>('');
  const [totalPages, setTotalPages] = useState(0);

  const [pageSize] = useState(10);
  const [pageNumber, setPageNumber] = useState(1);

  const [loading, setLoading] = useState<boolean>(false);

  const [memberValues, setMemberValues] = useState<MemberValues>({
    members: '0',
    employees: '0',
    dependents: '0',
  });
  const [pmpm, setPMPM] = useState<PMPM>({
    pmpm: '',
    pmpmPercentage: '',
    increment: true,
  });
  const [totalCost, setTotalCost] = useState<TotalCost>({
    totalCost: '',
    totalMedical: '',
    totalRx: '',
  });
  const [costValues, setCostValues] = useState<CostValues>({
    rx: '$0.00',
    medical: '$0.00',
    total: '$0.00',
  });

  const [riskMemberListData, setRiskMemberListData] = useState<any[]>([]);
  const [clickedMember, setClickedMember] = useState<string>('');
  const [selectedColumns, setSelectedColumns] = useState<string[]>(
    defaultSelectedColumns,
  );
  const [tableColumns, setTableColumns] = useState<Columns[]>(
    getColumns(defaultSelectedColumns),
  );

  const {
    overAllEnrolled,
    overallTotalCost,
    getTotalEligible,
  } = useTotalEligible(startDate, endDate, employerGroupStore);

  const [snackbarState, setSnackbarState] = React.useState<{
    open: boolean;
    message: string;
    severity: MuiColor | undefined;
    duration: null | number;
  }>({
    open: false,
    message: '',
    severity: undefined,
    duration: null,
  });
  const [sortField, setSortField] = useState<string>('totalCost');
  const [sortOrder, setSortOrder] = useState<number>(-1);

  //Functions
  const handleDateChange = () => {
    setStartDate(employerGroupStore?.selectedDuration?.startDate);
    setEndDate(employerGroupStore?.selectedDuration?.endDate);
  };

  const handlePageChange = (event: ChangeEvent<unknown>, page: number) => {
    setPageNumber(page);
  };

  const handleMemberClick = (value: string) => {
    setClickedMember(value);
  };

  const handleOpenSnackBar = (
    message: string,
    severity: MuiColor,
    duration: number | null,
  ) => {
    setSnackbarState({
      open: true,
      message: message,
      severity: severity,
      duration: duration,
    });
  };

  const handleCloseSnackBar = (
    event?: React.SyntheticEvent,
    reason?: string,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarState({
      open: false,
      message: '',
      severity: undefined,
      duration: null,
    });
  };

  const handleChangeColumns = () => {
    setTableColumns(getColumns(selectedColumns));
    getRiskMembersList();
  };

  const handleSort = (event: any, column: any, item: any) => {
    const sortOrder = item.actionType === 'ascendingSorting' ? 1 : -1;
    const { sortColumnName } = column;
    if (!sortColumnName) {
      return;
    }

    setSortField(sortColumnName);
    setSortOrder(sortOrder);
  };

  const handleExportCSV = () => {
    handleDownloadCSV(
      properties.aiqBaseUrl + properties.membersList + '/cohort-csv',
      { ...membersListRequestBody, showAll: true },
      `${type}.csv`,
      handleOpenSnackBar,
    );
  };

  const getMemberClaims = async (memberId: string) => {
    return await axios
      .post(
        properties.aiqBaseUrl +
          properties.membersBaseUrl +
          properties.memberDetails,
        {
          eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid,
          startDate: startDate,
          endDate: endDate,
          member_unique_id: [memberId],
          claim_id_list: [],
        },
      )
      .then((response) => response.data);
  };

  const membersListRequestBody = {
    eg_nid: employerGroupStore.employerGroupResponseData.eg_nid,
    startYear: moment(startDate, 'YYYY-MM-DD').year(),
    member_unique_id_list: [],
    pageNumber: pageNumber - 1,
    pageSize: pageSize,
    sortField: sortField,
    sortOrder: sortOrder,
    category: type,
    startDate: startDate,
    endDate: endDate,
    max_claim_date: employerGroupStore.employerGroupResponseData.max_claim_date,
    columnList: selectedColumns,
    showAll: previousYearCostSortFields?.includes(sortField),
    cohortFilters: toJS(cohortDetailsStore.cohortValues),
    // drugType: 'Glucagon-like Peptide-1 (glp-1) Analogues',
  };

  const getRiskMembersList = async () => {
    setLoading(true);

    const response = await axios.post(
      properties.aiqBaseUrl + properties.membersListCohort,
      membersListRequestBody,
    );

    if (response?.status === 200) {
      const updatedData = await Promise.all(
        response?.data?.data?.memberList?.map(async (item: any) => {
          const memberClaimsData = await getMemberClaims(item['Member ID']);
          return {
            ...item,
            claimData: memberClaimsData?.data,
          };
        }),
      );
      setMemberValues(formatMemberValues(response?.data?.data?.members));
      setTotalCost(
        formatTotalCost(
          {
            rxPaid: response?.data?.data?.total_rx_paid,
            medPaid: response?.data?.data?.total_med_paid,
            totalPaid:
              response?.data?.data?.total_rx_paid +
              response?.data?.data?.total_med_paid,
          },
          2,
        ),
      );
      setCostValues(
        formatCostValues({
          rxPaid: response?.data?.data?.total_rx_paid,
          medPaid: response?.data?.data?.total_med_paid,
          totalPaid:
            response?.data?.data?.total_rx_paid +
            response?.data?.data?.total_med_paid,
        }),
      );

      setTotalPages(Math.ceil(response?.data?.data?.totalMembers / pageSize));

      const pmpmResponse = await axios.post(
        properties.aiqBaseUrl +
          properties.summaryBaseUrl +
          properties.pmpmAndPepm,
        {
          startDate: startDate,
          endDate: endDate,
          eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid,
          claim_id_list: [],
          member_unique_id_list: response?.data?.data?.member_ids?.[0]?.members,
          max_claim_date:
            employerGroupStore?.employerGroupResponseData?.max_claim_date,
        },
      );

      setPMPM({
        pmpm: pmpmResponse?.data?.data?.pmpm?.pmpm
          ? numberToCurrencyFormatter(pmpmResponse?.data?.data?.pmpm?.pmpm)
          : '0',
        pmpmPercentage: '',
        increment: false,
      });

      setRiskMemberListData(
        formatMembersListData(updatedData, selectedColumns),
      );
      setLoading(false);
    }
  };

  //useEffects
  useEffect(() => {
    cohortDetailsStore.toggleCohortModal(true);
    setStartDate(employerGroupStore?.selectedDuration?.startDate);
    setEndDate(employerGroupStore?.selectedDuration?.endDate);
  }, []);

  const getAllCharts = async () => {
    setLoading(true);
    await Promise.all([getRiskMembersList(), getTotalEligible()]).then(() => {
      setLoading(false);
    });
  };

  useEffect(() => {
    Boolean(
      !cohortDetailsStore.openCohortModal && startDate !== '' && endDate !== '',
    )
      ? getAllCharts()
      : '';
  }, [
    cohortDetailsStore.openCohortModal,
    startDate,
    pageNumber,
    sortField,
    sortOrder,
  ]);

  useEffect(() => {
    if (clickedMember) {
      memberSummaryStore.setPathDetails([
        [
          'text',
          titleAndSubtitles[type]?.title,
          {
            color: patientAccessTheme.palette.primary[500],
            fontWeight: 500,
          },
        ],
      ]);
      navigate(PATIENT_DETAILS, { state: { memberId: clickedMember } });
    }
  }, [clickedMember]);

  const getModal = () => {
    const data: string[] = [];
    switch (type) {
      case 'chronic':
        data.push('chronic_conditions');
        break;
      case 'cost':
        data.push('high_cost_claimants');
        break;
      case 'drugs':
        data.push('multiple_drugs');
        break;
      default:
        return [];
    }
    return data;
  };

  const getCohortDetails = () => {
    let finalText: string = '';
    switch (type) {
      case 'chronic':
        finalText =
          'Chronic Disease is ' +
          (toJS(cohortDetailsStore.cohortValues)?.['chronic_conditions']?.join(
            ' | ',
          ) || '');
        return getTextWithToolTip(finalText, 150);
      case 'cost':
        finalText =
          'Member Per Month Cost greater than equal to ' +
          ('$' +
            toJS(cohortDetailsStore.cohortValues)?.['high_cost_claimants'] ||
            '');
        return finalText;
      case 'drugs':
        finalText =
          'Drug usage greater than equal to ' +
          (toJS(cohortDetailsStore.cohortValues)?.['multiple_drugs'] || '');
        return finalText;
      default:
        return '';
    }
  };

  return loading ? (
    <Loader />
  ) : (
    <>
      <Grid className={classes.root}>
        <Grid style={{ marginBottom: '19px' }}>
          <Breadcrumbs itemList={breadcrumbs} />
        </Grid>
        <PageTitleAndSubTitle
          title={titleAndSubtitles[type]?.title}
          chip={
            <Grid className={classes.flex}>
              <Typography
                fontSize="17px"
                lineHeight="21px"
                textColor={patientAccessTheme.palette.text.mediumemphasis}
                fontType="semiBold"
                margin="2px 8px 0px 0px"
              >
                for
              </Typography>
              <EditDurationModal
                isYearGrid={true}
                handleDateChange={handleDateChange}
              />
            </Grid>
          }
          subTitle={titleAndSubtitles[type]?.subTitle}
          // showQueryDataButton={checkUserAccess(
          //   UserAccessConstants.COHORT_DETAILS,
          //   loginPageStore.userResponse.role.name,
          //   loginPageStore.userFeatures,
          // )}
          queryButtonText={'Edit Cohort'}
          queryDataAction={() => {
            cohortDetailsStore.toggleCohortModal(true);
          }}
        />

        <Grid
          container
          direction="row"
          className={classes.queryDataOverallGrid}
        >
          <Grid className={classes.queryIconGrid}>
            <QueryIcon />
          </Grid>
          <Grid className={classes.queryDataGrid}>
            <Typography
              className={classes.queryDataTypography}
              lineHeight="25px"
              fontSize="14px"
              fontType="regular"
            >
              {getCohortDetails()}
            </Typography>
          </Grid>
        </Grid>

        <Grid style={{ display: 'flex', margin: '29px 0px' }}>
          <Grid style={{ marginRight: '24px' }}>
            <OverviewCardTooltipContent
              type="member"
              cohortMemberValues={memberValues}
              totalMemberValues={{
                dependents: overAllEnrolled.dependents,
                employees: overAllEnrolled.employees,
                members: overAllEnrolled.totalCount,
              }}
              overviewCard={
                <OverviewCard
                  title={titleAndSubtitles.CARDS.MEMBERS}
                  value={getCohortValue(
                    memberValues.members,
                    overAllEnrolled.totalCount,
                  )}
                  rootStyles={{
                    width: '176px',
                    height: '100px',
                  }}
                />
              }
            />
          </Grid>

          <Grid style={{ marginRight: '24px' }}>
            <OverviewCardTooltipContent
              type="cost"
              cohortCostValues={costValues}
              totalCostValues={{
                medical: overallTotalCost.totalMedical,
                rx: overallTotalCost.totalRx,
                total: overallTotalCost.totalCost,
              }}
              overviewCard={
                <OverviewCard
                  title={titleAndSubtitles.CARDS.TOTAL_COST}
                  value={getCohortValue(
                    (totalCost?.totalCost).toString(),
                    overallTotalCost.totalCost,
                  )}
                  rootStyles={{
                    width: '216px',
                  }}
                />
              }
            />
          </Grid>

          <Grid style={{ marginRight: '24px' }}>
            <OverviewCard
              title={titleAndSubtitles.CARDS.PMPM}
              value={getPmpmValueForCohorts(pmpm, [], [])}
              rootStyles={{
                width: '176px',
                height: '100px',
              }}
            />
          </Grid>
        </Grid>

        <Grid id="member-details" className={classes.customTable}>
          <CustomColumnsTable
            title={
              <Grid className={classes.flex}>
                <Typography
                  fontSize="16px"
                  lineHeight="24px"
                  textColor={patientAccessTheme.palette.text.highemphasis}
                  fontType="semiBold"
                  margin="2px 8px 0px 0px"
                >
                  Member Details
                </Typography>
              </Grid>
            }
            subTitle={'Showing details of members part of the selected cohort'}
            options={columnsDropdownOptions.filter((_, index) => index !== 2)}
            mandateOptions={['Member ID']}
            selectedItems={selectedColumns}
            setSelectedItems={setSelectedColumns}
            handleChangeColumns={handleChangeColumns}
            handleExport={handleExportCSV}
            columns={tableColumns}
            rowsData={riskMemberListData}
            tableLoading={loading}
            handleMemberClick={handleMemberClick}
            handleSort={handleSort}
            totalPages={totalPages}
            handlePageChange={handlePageChange}
            pageNumber={pageNumber}
          />
        </Grid>
        <div id="scroll-top-element" />
        {pageScrollDown('scroll-top-element')}
      </Grid>
      <CohortAnalysisModal cohortTypes={getModal()} />
      <Snackbar
        {...snackbarState}
        handleClose={handleCloseSnackBar}
        vertical="bottom"
        horizontal="right"
      />
    </>
  );
});

export default CohortScreen;
